"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Toggler = require("b2b-components/theme/components/Dropdown/Dropdown/Toggler");
var _classnames = _interopRequireDefault(require("classnames"));
var _List = require("./List");
require("./Dropdown.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    className = _ref.className,
    isMenuVisible = _ref.isMenuVisible,
    links = _ref.links,
    content = _ref.content,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    dropdownTogglerRef = _ref.dropdownTogglerRef,
    dropdownMenuRef = _ref.dropdownMenuRef,
    menuPositionConfig = _ref.menuPositionConfig,
    hasPositionCalculated = _ref.hasPositionCalculated,
    togglerProps = _ref.togglerProps;
  var List = Dropdown.List,
    Toggler = Dropdown.Toggler;
  var left = menuPositionConfig.left,
    arrowLeft = menuPositionConfig.arrowLeft,
    width = menuPositionConfig.width;
  var rootClassName = (0, _classnames["default"])('cds-Dropdown', className);
  var togglerClassName = (0, _classnames["default"])('cds-Dropdown-Toggler', (0, _defineProperty2["default"])({}, "".concat(togglerProps === null || togglerProps === void 0 ? void 0 : togglerProps.className), togglerProps === null || togglerProps === void 0 ? void 0 : togglerProps.className));
  var getStyleAttribute = function getStyleAttribute(attributeName, value) {
    if (value !== null) {
      return (0, _defineProperty2["default"])({}, attributeName, "".concat(value, "px"));
    }
    return {};
  };
  var renderContent = (0, _react.useCallback)(function () {
    if (links && Array.isArray(links)) {
      return /*#__PURE__*/_react["default"].createElement(List, {
        links: links
      });
    }
    if (content) {
      return content;
    }
    return null;
  }, [links, content, List]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: dropdownTogglerRef
  }, children || /*#__PURE__*/_react["default"].createElement(Toggler, (0, _extends2["default"])({}, togglerProps, {
    className: togglerClassName
  })), isMenuVisible && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Dropdown-Menu",
    style: _objectSpread(_objectSpread(_objectSpread({}, !hasPositionCalculated && {
      opacity: 0
    }), getStyleAttribute('left', left)), getStyleAttribute('width', width)),
    ref: dropdownMenuRef
  }, renderContent(), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Dropdown-MenuArrow",
    style: _objectSpread({}, getStyleAttribute('left', arrowLeft))
  })));
};
exports.Dropdown = Dropdown;
Dropdown.Toggler = _Toggler.Toggler;
Dropdown.List = _List.List;